export var Provider;
(function (Provider) {
    Provider["CHARGEBEE"] = "Chargebee";
    Provider["STRIPE"] = "Stripe";
})(Provider || (Provider = {}));
export var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["ACTIVE"] = "Active";
    SubscriptionStatus["CANCELLED"] = "Cancelled";
    SubscriptionStatus["UNKNOWN"] = "Unknown";
})(SubscriptionStatus || (SubscriptionStatus = {}));
export var Plans;
(function (Plans) {
    Plans["FREE"] = "free";
})(Plans || (Plans = {}));
